import { isNil, isEmpty } from 'lodash/lang';
import getDateString from '@utils/date/get-date-string';

export default {
  name: 'chat-box',
  props: {
    newMessage: {
      type: Object,
      default: null,
    },
    messagesData: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    extraClass() {
      return {
        'chat-box--empty': this.isEmptyChat,
        'chat-box--single': this.isSingleMessage,
      };
    },

    isEmptyChat() {
      return !isNil(this.messagesData)
        && isEmpty(this.messagesData)
        && isNil(this.newMessage);
    },

    isSingleMessage() {
      return this.messagesData.length === 1;
    },
  },

  methods: {
    getTodayLabel() {
      return getDateString(new Date());
    },
  },
};
